/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

import { getConfig } from '../lib/config.js';
import { initEditorial } from '../lib/editorial.js';
import { on } from '../lib/events.js';
import { injectParams, isExternalLink } from '../lib/links.js';
import { cookie } from '../lib/cookie.js';
import { Tabs } from '../lib/tabs.js';

/** The tab strip, once built. Other handlers close it through this. */
export let tabs = null;

export function init() {
    const cfg = getConfig() || {};

    const tabsEl = document.querySelector('.tabs');
    if (tabsEl) {
        // The map pans and zooms on these gestures, and the strip sits on
        // top of it.
        ['mousedown', 'touchstart', 'wheel'].forEach((name) => {
            tabsEl.addEventListener(name, (event) => {
                event.stopPropagation();
            });
        });
    }
    tabs = Tabs(tabsEl);

    const editorialUrl = injectParams(cfg.endpoints.mapEditorial, {
        lang: cfg.i18n.lang,
        preview: cfg.map.isPreview ? 1 : null,
    });

    initEditorial(document.getElementById('editorial'), editorialUrl).then(
        (rendered) => {
            if (!rendered) return;
            document
                .querySelectorAll('#editorial .close a[href]')
                .forEach((a) => {
                    a.addEventListener('click', tabs.closeTab);
                    a.addEventListener('touchstart', tabs.closeTab);
                });
            // A link out of the panel leaves it open behind the new page;
            // one within the map should hand the map back.
            document
                .querySelectorAll('#editorial section a[href]')
                .forEach((a) => {
                    const handler = () => {
                        if (!isExternalLink(a.href)) tabs.closeTab();
                    };
                    a.addEventListener('click', handler);
                    a.addEventListener('touchstart', handler);
                });
        }
    );

    on('cookieConsent:revoke:essential', () => {
        cookie.erase('editorials');
    });
}
